import styled from 'styled-components';

export const Contain = styled.div`
  height: 100%;
  width: 98%;
  margin: auto;
  section {
    padding: 0 5px;
  }
  #ComponenteInputDropdown {
    padding: 30px 0 10px 0;
  }
  #exibirEditorTexto {
    margin-top: 6px !important;
    padding: 0px 10px 10px 15px !important;
    font-size: 9pt;
  }
`;

export const ContainButton = styled.div`
  width: 98%;
  margin: auto;
  margin-top: 20px;
  margin-bottom: 15px;
  display: flex;
  button {
    margin-right: 10px;
  }
`;

//Atendente

export const ContainForm = styled.div`
  width: 98%;
  margin: auto;
`;

export const ImagemAtendente = styled.img`
  padding: 8px;
  width: 80%;
`;

export const DescricaoAtendente = styled.p`
  font-size: var(--font-tamanho);
`;

//Servico Duvida

export const ContainTamanhoArq = styled.div`
  width: 98%;
  margin: auto;
  margin-top: 10px;
`;

export const tituloGrid = styled.div`
  font-weight: 500;
  margin-bottom: 15px;
  font-size: var(--font-tamanho);
`;

export const DescricaoServico = styled.div`
  font-size: 12pt;
  border-radius: 10px;
  padding: 5px;
  overflow: hidden;

  svg {
    margin-right: 10px;
    color: red;
    animation-name: colorDescricaoServico;
    animation-duration: 4s;
    animation-iteration-count: infinite;
  }
  p {
    margin: 0px;
    border-bottom: 1px solid #000000;

    border-image-slice: 1;
    border-radius: 20px;

    animation-name: descricaoServico;
    animation-duration: 2s;
    animation-iteration-count: infinite;

    @keyframes descricaoServico {
      0% {
        border-image: linear-gradient(0.25turn, #000000, #000000, #000000);
        border-image-slice: 1;
      }
      25% {
        border-image: linear-gradient(0.25turn, #1dfdef, #000000, #000000);
        border-image-slice: 1;
      }
      50% {
        border-image: linear-gradient(0.25turn, #000000, #1dfdef, #000000);
        border-image-slice: 1;
      }
      75% {
        border-image: linear-gradient(0.25turn, #000000, #000000, #1dfdef);
        border-image-slice: 1;
      }
      100% {
        border-image: linear-gradient(0.25turn, #000000, #000000, #000000);
        border-image-slice: 1;
      }
    }
    @keyframes colorDescricaoServico {
      0% {
        color: #0078bb;
      }
      50% {
        color: #000000;
      }
      100% {
        color: #0078bb;
      }
    }
  }
`;

export const fraseArquivo = styled.p`
  font-size: 10pt;
  margin: 0px;
`;

//Servico Sistema

export const Descricao = styled.p`
  margin: 20px 0px;
`;

export const ImagemServicoSistema = styled.img`
  padding: 8px;
  width: 70%;
  margin-left: auto;
`;

//Setor Sistema

export const ImagemSetorSistema = styled.img`
  padding: 8px;
  width: 50%;
  margin-left: auto;
`;

export const ImagemPostosAtendimento = styled.img`
  padding: 8px;
  width: 50%;
  margin-left: auto;
`;

export const AtendentesRowEmpty = styled.div`
  display: flex;
  align-items: center;
  font-size: 10pt;
  span {
    margin-right: 10px;
    font-size: 13pt;
  }
`;

export const LinkAtendente = styled.p`
  cursor: pointer;
  color: #40b1ff;
`;

export const AtendenteDescricao = styled.p`
  cursor: pointer;
  padding: 0px 10px;
  transition-delay: 0.1s;

  &:hover {
    background-color: var(--cinza-color);
  }
`;
